import React from 'react';
import { Box, MenuItem, Select, SelectProps, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// @ts-ignore
import cx from 'classnames';

export type MenuItemType = {
  id: string | number;
  name: string;
  disabled?: boolean;
  items?: MenuItemType[];
}

export interface EeSelectProps extends SelectProps {
  onChange?: (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode,
  ) => void;
  value: string | number;
  label?: string;
  items: MenuItemType[];
  className?: string;
  disabled?: boolean;
  hidden?: boolean;
  displayEmpty?: boolean;
  error?: boolean;
}

export const EeSelect: React.FC<EeSelectProps> = ({
  label,
  value,
  items = [],
  disabled,
  className,
  onChange,
  displayEmpty,
  defaultValue,
  hidden,
  error,
  classes,
  ...otherProps
}) => {

  const isNested = !!items.filter(i => i.items && i.items.length).length;

  function renderItem(item: MenuItemType, depth: number): JSX.Element[] {
    const itemNode = (
      <MenuItem
        key={`select-item-${item.id}`}
        value={item.id}
        disabled={item.disabled}
      >
        <Box pl={depth}>
          {
            depth === 0 && isNested
            ? <strong>{item.name}</strong>
            : item.name
          }
        </Box>
      </MenuItem>
    );
    const childrenNodes = item.items?.map(i => renderItem(i, depth+1)) || [];
    return [itemNode].concat(childrenNodes.flat());
  }

  return (
    <div
      className={cx(
        {
          'd-flex align-items-center mb-2': label,
          'is-disabled': disabled,
        },
        className,
      )}
      hidden={hidden}
    >
      {label && (
        <Typography className="ee-label" variant="subtitle1">
          {label}
        </Typography>
      )}
      <Select
        disabled={disabled}
        autoWidth
        onChange={onChange}
        value={value}
        defaultValue={defaultValue}
        disableUnderline
        displayEmpty={displayEmpty}
        IconComponent={ExpandMoreIcon}
        error={error}
        classes={classes}
        {...otherProps}
      >
        {items.length > 0 && items.map(i => renderItem(i, 0))}
      </Select>
    </div>
  );
};
